import { useEffect } from "react";
import "./index.scss";
import "react-toastify/dist/ReactToastify.min.css";

import { BrowserRouter, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ErrorBoundary } from "react-error-boundary";

import AppRouter from "./AppRouter";
import Navbar from "components-layout/Navbar";
import Footer from "components-layout/Footer";
import { routes } from "./routes";

import { AppContextProvider } from "contexts/AppContext";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function AppWrapper() {
  const location = useLocation();

  const isMajikPage = location.pathname === routes.Majik_;
  return (
    <>
      <ScrollToTop />
      <AppContextProvider>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        {/* Conditionally render Navbar */}
        {!isMajikPage && <Navbar />}

        <div className={"mainWrapper"}>
          <AppRouter />
        </div>

        {/* Conditionally render Footer */}
        {!isMajikPage && <Footer />}
      </AppContextProvider>
    </>
  );
}

function App() {
  return (
    <ErrorBoundary
      fallback={
        <>
          <div>Fatal Error</div>
        </>
      }
    >
      <AppContextProvider>
        <BrowserRouter>
          <AppWrapper />
        </BrowserRouter>
      </AppContextProvider>
    </ErrorBoundary>
  );
}

export default App;
